import './style.scss';

import classNames from 'classnames';
import { motion } from 'framer-motion';
import { ReactNode, useCallback } from 'react';

import { useTypedDispatch } from 'store';
import { setCopyPopupShow } from 'store/slices/ui';
import { copyToClipboard } from 'utils/clipboard';

interface ICopyableProps {
  label: ReactNode;
  value: string;
  className?: string;
}

export default function Copyable({ value, label, className }: ICopyableProps) {
  const dispatch = useTypedDispatch();

  const handleCopy = useCallback(
    async (value?: string) => {
      if (!value) return;

      try {
        await copyToClipboard(value);
        dispatch(setCopyPopupShow(true));
      } catch (error) {
        console.log('error: ', error);
      }
    },
    [dispatch],
  );

  return (
    <div className="mm-day-trader-copyable">
      <div className="container">
        <motion.span
          onClick={() => handleCopy(value)}
          whileHover={value ? { scale: 1.05 } : undefined}
          className={classNames('label', className)}
        >
          {label}
        </motion.span>
      </div>
    </div>
  );
}
